webpackJsonp([26],{

/***/ 1291:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ForumThread_vue__ = __webpack_require__(3544);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08b6bfa6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ForumThread_vue__ = __webpack_require__(4308);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(4306)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ForumThread_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08b6bfa6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ForumThread_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/views/healthy-community/forum/ForumThread.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-08b6bfa6", Component.options)
  } else {
    hotAPI.reload("data-v-08b6bfa6", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 3544:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_forum_mixin__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_editor__ = __webpack_require__(1269);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import _ from 'lodash'

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'forum-thread',
  components: {
    'base-button': function baseButton() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 124)).then(function (m) {
        return m.default;
      });
    },
    'forum-article-block': function forumArticleBlock() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1268)).then(function (m) {
        return m.default;
      });
    },
    'forum-message-block': function forumMessageBlock() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1290)).then(function (m) {
        return m.default;
      });
    },
    VueEditor: __WEBPACK_IMPORTED_MODULE_1_vue2_editor__["a" /* VueEditor */]
  },
  props: {},
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_forum_mixin__["a" /* default */]],
  data: function data() {
    return {
      entryId: null,
      numReplies: null,
      viewRestricted: false
    };
  },
  created: function created() {
    if (!this.$store.getters['session/isLogged']) {
      this.viewRestricted = true;
    }
    if (!this.$store.state.forum.editingEntry) {
      this.$store.state.forum.showMainAnswerBlock = false;
    }
    this.entryId = this.$route.params.id;
    this.getForumEntry();
  },

  computed: {},
  methods: {
    getForumEntry: function getForumEntry() {
      var _this = this;

      this.$api.get('/Forum/GetEntry', { params: { entryId: this.entryId, sectionId: this.$store.state.forum.sectionId } }).then(function (response) {
        if (response.data) {
          _this.$store.state.forum.entriesCreatedByUser = response.data.entriesCreatedByUser;
          _this.$store.state.forum.numEntries = response.data.numEntries;
          _this.$store.state.forum.articleData = response.data.entryData;
          _this.numReplies = response.data.entryData[0].numReplies;
          _this.$store.state.forum.messagesPageNumber = [];
          if (!_this.viewRestricted) {
            _this.getForumMessages(_this.entryId);
          }
        } else {
          _this.$store.dispatch('showDangerAlert', _this.$t('defaultErrorMessage'));
        }
      });
    },
    updatePostData: function updatePostData() {
      var _this2 = this;

      this.$store.state.forum.messagesPageNumber = [];
      this.getForumMessages(this.entryId);
      var article = this.$store.state.forum.articleData.find(function (item) {
        return item.id === _this2.entryId;
      });
      article.totalMessages = !article.totalMessages ? 1 : ++article.totalMessages;
    },
    sendMessage: function sendMessage() {
      var _this3 = this;

      if (!this.$store.state.forum.wysiwygEntryAnswer) {
        this.$store.dispatch('showDangerAlert', this.$t('emptyMessageError'));
        return;
      }

      if (this.$store.state.forum.editingEntry) {
        this.$api.put('/Forum/EditEntry', null, { params: { entryId: this.entryId, description: this.$store.state.forum.wysiwygEntryAnswer } }).then(function (response) {
          if (response.data) {
            _this3.$store.state.forum.wysiwygEntryAnswer = null;
            _this3.$store.state.forum.editingEntry = false;
            _this3.$store.state.forum.showMainAnswerBlock = false;
            _this3.$store.dispatch('showSuccessAlert', _this3.$t('changesPerformedCorrectly'));
            _this3.getForumEntry();
            _this3.updateLastInteractionDate(_this3.entryId);
          } else {
            _this3.$store.dispatch('showDangerAlert', _this3.$t('defaultErrorMessage'));
          }
        });
      } else {
        this.$api.post('/Forum/SendEntryMessage', { entryReferenceId: this.entryId, message: this.$store.state.forum.wysiwygEntryAnswer, sectionId: this.$store.state.forum.sectionId }).then(function (response) {
          if (response.data) {
            _this3.updatePostData();
            _this3.$store.state.forum.wysiwygEntryAnswer = null;
            _this3.$store.state.forum.showMainAnswerBlock = false;
            if (_this3.$store.getters['forum/forumMessageWithoutValidation']) {
              _this3.updateLastInteractionDate(_this3.entryId);
              _this3.$store.dispatch('showSuccessAlert', _this3.$t('messagePublishedSuccessfully'));
            } else {
              _this3.$store.dispatch('showSuccessAlert', _this3.$t('messagePendingValidation'));
            }
          } else {
            _this3.$store.dispatch('showDangerAlert', _this3.$t('defaultErrorMessage'));
          }
        });
      }
    },
    goBack: function goBack() {
      this.$store.state.forum.wysiwygEntryAnswer = null;
      this.$store.state.forum.editingEntry = false;
      this.$store.state.forum.showMainAnswerBlock = false;
    }
  }
});

/***/ }),

/***/ 4306:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4307);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("41f1f4e5", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-08b6bfa6\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ForumThread.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-08b6bfa6\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ForumThread.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 4307:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active,.slide-down-leave-active{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter,.slide-down-leave-to{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active,.slide-fade-left-leave-active{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter,.slide-fade-left-leave-to{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter,.fade-leave-to{opacity:0\n}\n.reply-entry-btn{margin-bottom:2% !important\n}\n@media only screen and (max-width: 575px){\n.reply-entry-btn{margin-top:2% !important\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.reply-entry-btn{margin-top:2% !important\n}\n}\n", ""]);

// exports


/***/ }),

/***/ 4308:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("forum-article-block", {
        staticStyle: { "margin-bottom": "2%" },
        attrs: {
          hideFooter: _vm.viewRestricted,
          showImage: "",
          disableClick: "",
          showAnswerBtn: "",
          showFullWhoInDescription: ""
        }
      }),
      _vm._v(" "),
      _vm.$store.state.forum.showMainAnswerBlock
        ? _c(
            "div",
            [
              _c("vue-editor", {
                staticClass: "wysiwygStyle wysiwygReduced",
                attrs: { useCustomImageHandler: "" },
                on: { "image-added": _vm.handleImageAdded },
                model: {
                  value: _vm.$store.state.forum.wysiwygEntryAnswer,
                  callback: function($$v) {
                    _vm.$set(_vm.$store.state.forum, "wysiwygEntryAnswer", $$v)
                  },
                  expression: "$store.state.forum.wysiwygEntryAnswer"
                }
              }),
              _vm._v(" "),
              _c(
                "base-button",
                {
                  staticClass: "reply-entry-btn",
                  staticStyle: { margin: "2% 0" },
                  on: { click: _vm.sendMessage }
                },
                [_vm._v(_vm._s(_vm.$t("send")))]
              ),
              _vm._v(" "),
              _c(
                "base-button",
                {
                  staticStyle: { margin: "2% 0" },
                  attrs: { gray: "", outline: "" },
                  on: { click: _vm.goBack }
                },
                [_vm._v(_vm._s(_vm.$t("cancel")))]
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.viewRestricted
        ? _c("div", { staticClass: "verticalCenter" }, [
            _c(
              "div",
              {
                staticClass: "forumArticle",
                staticStyle: { "margin-bottom": "2%" }
              },
              [
                _c(
                  "p",
                  { staticStyle: { margin: "1.5rem" } },
                  [
                    _vm._v(_vm._s(_vm.$t("loginFromArticle")) + "\n        "),
                    _c(
                      "base-button",
                      {
                        staticClass: "btn btn-primary fixed-padding-btn-forum",
                        on: {
                          click: function($event) {
                            return _vm.logIn("quienseapunta/" + _vm.entryId)
                          }
                        }
                      },
                      [
                        _c("span", [_vm._v(_vm._s(_vm.$t("accessBtn")))]),
                        _vm._v(" "),
                        _c("base-icon", {
                          attrs: {
                            src:
                              "/static-appopensalud/img/icons/morillas-svg-icons/primary/arrow.svg",
                            color: "white"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            )
          ])
        : _c("forum-message-block", {
            attrs: {
              numPrincipalReplies: _vm.numReplies,
              entryReferenceId: _vm.entryId
            }
          })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-08b6bfa6", esExports)
  }
}

/***/ })

});


// WEBPACK FOOTER //
// static-appopensalud/js/26.9dac0fa3da05481cfb38.js